import {createReferralCampaignProductListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ReferralCampaignProductListItemSchema = z.object({
  // crmId: z.string(),
  // name: z.string(),
  // code: z.string(),
  // category: z.string(),
  // price: z.number(),
  // isSelected: z.boolean(),
  // id: z.string(),
  // brand: z.string().nullable(),
  id: z.string(),
  code: z.string(),
  name: z.string(),
  category: z.string(),
  createdOn: z.string(),
})

export const ReferralCampaignProductListSchemaResponse =
  createReferralCampaignProductListResponseSchema(ReferralCampaignProductListItemSchema.array())

export type ReferralCampaignProductListItem = z.infer<typeof ReferralCampaignProductListItemSchema>
export type ReferralCampaignProductList = z.infer<typeof ReferralCampaignProductListSchemaResponse>
export type ReferralCampaignProductListResponse = z.infer<
  typeof ReferralCampaignProductListSchemaResponse
>

export type ReferralCampaignProductListAllItem = z.infer<
  typeof ReferralCampaignProductListItemSchema
>
export type ReferralCampaignProductListAll = z.infer<
  typeof ReferralCampaignProductListSchemaResponse
>
export type ReferralCampaignProductListAllResponse = z.infer<
  typeof ReferralCampaignProductListSchemaResponse
>
